import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { t } from "@/i18n-js/instance";
import { useMarkAllChatThreadsAsRead } from "@/react/hooks/chatsV2/threads/useMarkAllChatThreadsAsRead";

export const MarkAsReadButton = () => {
  const { markAllChatThreadsAsRead, isLoading } = useMarkAllChatThreadsAsRead();

  return (
    <Tooltip content={t("header_v3.mark_all_as_read")}>
      <IconButton
        icon="checkmark-double"
        variant="ghost"
        loading={isLoading}
        size="md"
        onClick={() => markAllChatThreadsAsRead()}
        aria-label={t("header_v3.mark_all_as_read")}
      />
    </Tooltip>
  );
};
